import React from 'react';
import { useFadeInOnScroll } from '../../hooks/useScrollEffects';
import './FAQSection.css';

const FAQSection = () => {
  // Hooks para efeitos de scroll com layers sincronizados
  const { isVisible: questionVisible, elementRef: questionRef, transformStyle: questionTransform } = useFadeInOnScroll('TITLE');
  const { isVisible: answerVisible, elementRef: answerRef, transformStyle: answerTransform } = useFadeInOnScroll('CONTENT');

  const scrollToHero = () => {
    const heroSection = document.getElementById('hero-section');
    if (heroSection) {
      heroSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <div className="faq-section">
      <div className="faq-main-container">
        {/* Container com efeito de vidro apenas para a pergunta */}
        <div 
          ref={questionRef}
          className={`faq-question-container scroll-fade-in ${questionVisible ? 'visible' : ''}`}
          style={questionTransform}
        >
          <div className="faq-header">
            <div className="faq-glass-card">
              <div className="faq-card-content">
                <h2 className="section-title">
                  Se você é rico com o Trade, por que ensinar a estratégia?
                </h2>
              </div>
              <div className="faq-blur-bottom"></div>
              <div className="faq-blur-top"></div>
            </div>
          </div>
          
          <div className="faq-decorative-effects">
            <div className="faq-blur-effect-1"></div>
            <div className="faq-blur-effect-2"></div>
          </div>
        </div>

        {/* Container sem efeito de vidro para a resposta */}
        <div 
          ref={answerRef}
          className={`faq-answer-container scroll-fade-in ${answerVisible ? 'visible' : ''}`}
          style={answerTransform}
        >
          <div className="faq-answer">
            <h3 className="faq-answer-title">
              Entenda: te fazer rico, não vai me deixar pobre.
            </h3>
            <div className="faq-answer-text">
              <p>
                O mercado financeiro é composto majoritariamente por investidores externos, o fluxo de dinheiro não vem dos traders iguais a mim, não importa quanto dinheiro eu ganhe na vida, eu jamais terei tanto dinheiro quanto os fundos internacionais que aportam no país.
              </p>
              <p>
                Por isso que a lógica da escassez "se ele ganha dinheiro mesmo com isso, não ia perder tempo me ensinando" é uma das maiores falácias existentes. Outro fator que os acomodados nunca consideram é a satisfação pessoal em ver outras pessoas sucederem.
              </p>
              <p>
                Eu vim do nada, conquistei estabilidade, bens materiais e liberdade, eu quero que outras pessoas que vieram do nada consigam também. Quando vocês lucram, eu lucro. Ganhar dinheiro sozinho no mercado é solitário e depois de um certo tempo não traz satisfação nenhuma, agora quando vejo as pessoas conquistando em meses o que eu levei anos pra conseguir me traz uma alegria imensa.
              </p>
              <p>
                Por isso reforço o meu convite para fazer parte do webinário onde eu vou mostrar os meus 3 segredos para lucrar no mercado financeiro:
              </p>
            </div>
          </div>
          
          <button className="cta-button" onClick={scrollToHero}>
            Vagas Limitadas!
          </button>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
